import type { CrudFilters } from "@refinedev/core";
import { mapOperator } from "./mapOperator";

export const generateFilter = (filters?: CrudFilters) => {

  const queryFilters: { [key: string]: string | string[] } = {};

  if (filters) {
    filters.forEach((filter) => {
      if (filter.operator === "or" || filter.operator === "and") {
        throw new Error(
          `[@refinedev/simple-rest]: \`operator: ${filter.operator}\` is not supported.`,
        );
      }

      if ("field" in filter) {
        const { field, operator, value } = filter;

        if (value === undefined || value === null || value === "") return;

        const key = `filter.${field}`;
        const operatorPrefix = mapOperator(operator);

        if (field === "q") {
          queryFilters[field] = value;
          return;
        }

        if (field === "search") {
          queryFilters[field] = value.trim().replace(/\s+/g, '%');
          return;
        }

        const stringValue = `${operatorPrefix}${value}`;

        if (queryFilters[key]) {
          if (Array.isArray(queryFilters[key])) {
            (queryFilters[key] as string[]).push(stringValue);
          } else {
            queryFilters[key] = [queryFilters[key] as string, stringValue];
          }
        } else {
          queryFilters[key] = stringValue;
        }
      }
    });
  }

  return queryFilters;
};

